import { ReactNode } from 'react';

import { Disclosure } from '@headlessui/react';
import { AnimatePresence } from 'framer-motion';
import styled from 'styled-components';

import { Collapse } from '@components/animators/collapse';
import { Rotate } from '@components/animators/Rotate';
import { IconDropdown } from '@components/icons/dropdown';
import { Text, TextProps } from '@components/text';
import { Color, theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type ElementAccordionProps = {
  label: string;
  children: ReactNode;
  font?: TextProps['font'];
  fontColor?: Color;
};

export const ElementAccordion = ({
  children,
  label,
  font = 'semibold14',
  fontColor = 'textPrimary',
}: ElementAccordionProps) => {
  return (
    <Disclosure defaultOpen>
      {({ open }) => (
        <div>
          <Disclosure.Button as={Header}>
            <Text font={font} color={fontColor} text={label} />
            <AnimatePresence initial={false}>
              <Rotate isRotated={!open} degrees={-90}>
                <IconDropdown key="down" color="purple50" />
              </Rotate>
            </AnimatePresence>
          </Disclosure.Button>
          <Disclosure.Panel static>
            <Collapse isCollapsed={!open}>{children}</Collapse>
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
};

const Header = styled.button({
  borderRadius: pxToRem(4),
  padding: `0 ${pxToRem(8)}`,
  background: 'transparent',
  width: '100%',
  height: pxToRem(32),
  display: 'flex',
  gap: pxToRem(8),
  alignItems: 'center',
  transition: 'background .3s ease-out',
  cursor: 'pointer',

  '&:hover': {
    background: theme.color.uiTrans5,
  },
});
